import React, { useState } from "react";

const DropdownMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");
    return (
      <>
        <div ref={ref} className={className} aria-labelledby={labeledBy} style={{ width: "100%" }}>
          <ul className="dropdown mb0">
            {React.Children.toArray(children).filter(
              (child) => !value || child.props.children.toLowerCase().startsWith(value)
            )}
          </ul>
        </div>
      </>
    );
  }
);
export default DropdownMenu;
